import { Box } from "@mui/material";
import { ReactNode } from "react";

import AppIcon from "@/common/components/Icons/AppIcon";
import AppLink from "@/common/components/Link/AppLink";
import { VehicleModelDto, VehicleModelReferenceDto } from "@/core/api/generated/v1";

import AppTooltip from "../../../Tooltip/AppTooltip";

interface Props {
  model: VehicleModelDto | VehicleModelReferenceDto | null | undefined;
  withIcon?: boolean;
  withLink?: boolean;
  withTooltip?: boolean;
  tooltipTitle?: ReactNode;
}

export default function VehicleModelInline({
  model,
  withIcon = true,
  withLink = true,
  withTooltip = false,
  tooltipTitle,
}: Props) {
  if (!model) {
    return null;
  }

  // const full = model as VehicleModelDto;
  // const ref = model as VehicleModelReferenceDto;

  return (
    <AppTooltip isEnabled={withTooltip} title={tooltipTitle || "Vehicle model"}>
      <AppLink
        // enabled={withLink}
        // to={
        //   (withLink &&
        //     ROUTE_PATH.VEHICLE_VISUAL_MODEL_VIEW({ vehicleVisualModelId: visualModel.id! })) ||
        //   ""
        // }
        isEnabled={false}
        to=''
        sx={{
          display: "inline-flex",
          alignItems: "center",
          fontSize: "inherit",
          underline: "none",
        }}
      >
        {withIcon && <AppIcon of='vehicleModel' inText sx={{ mr: 1 }} />}

        <Box component='span'>{model.name}</Box>
      </AppLink>
    </AppTooltip>
  );
}
